import {
  Box,
  Divider,
  Typography,
  Tabs,
  Tab,
  SxProps,
  Theme,
} from '@mui/material'
import { useState } from 'react'

interface CustomTabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
  sx?: SxProps<Theme>
}

function CustomTabPanel(props: CustomTabPanelProps) {
  const { children, value, index, sx, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={sx}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

export interface TabPanelProps {
  sx?: SxProps<Theme>
  customTabPanelSx?: SxProps<Theme>
  tabsConfig: {
    label: string
    content: React.ReactNode
  }[]
  value?: number
  onChange?: (value: number) => void
}

export const TabPanel = ({
  tabsConfig,
  customTabPanelSx = { p: 3, mt: 2 },
  sx,
  value: controlledValue,
  onChange,
}: TabPanelProps) => {
  const [uncontrolledValue, setUncontrolledValue] = useState(0)
  const value = controlledValue ?? uncontrolledValue

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (onChange) {
      onChange(newValue)
    } else {
      setUncontrolledValue(newValue)
    }
  }

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={sx}
      >
        {tabsConfig.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Divider />
      {tabsConfig.map((tab, index) => (
        <CustomTabPanel
          key={index}
          value={value}
          index={index}
          sx={customTabPanelSx}
        >
          {tab.content}
        </CustomTabPanel>
      ))}
    </>
  )
}
